// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"yndHk38W"};